import portal from './portal';
import home from './home';
import artist from './artist/index';

export default {
  portal,
  home,
  artist
}



// WEBPACK FOOTER //
// ./src/locales/no/page/index.js